import classNames from 'classnames'
import { JSX, PropsWithChildren } from 'react'

import styles from './TitleWrapper.module.scss'

interface IProps extends PropsWithChildren {
  variant?: 'withBackground' | 'withLightBackground' | 'default'
  align?: 'left' | 'right' | 'center'
  rightContent?: JSX.Element
  className?: string
}

export const TitleWrapper = ({ children, variant, rightContent, align, className }: IProps) => {
  const mods = {
    [styles.background]: variant === 'withBackground',
    [styles.lightBackground]: variant === 'withLightBackground',
    [styles.center]: align === 'center',
    [styles.right]: align === 'right',
  }
  return (
    <div className={classNames(styles.root, mods, className)}>
      {children}
      {rightContent}
    </div>
  )
}
